import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { selectCurrentSalonCalendarMode } from 'selectors/currentSalon.selectors';

import CN from './Card.module.scss';

const Card = ({ children, withShadow, calendarMode }) => {
  const cardClasses = cn({
    [CN.component]: true,
    [CN.shadow]: withShadow,
    [CN.dark]: calendarMode === 'dark',
    dark: calendarMode === 'dark',
  });

  return (
    <div data-bem="Card" className={cardClasses}>
      {children}
    </div>
  );
};
const mapStateToProps = (state) => ({
  calendarMode: selectCurrentSalonCalendarMode(state),
});

export default connect(
  mapStateToProps,
  null,
)(Card);
